<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="8" class="box">
            <div class="box2">
              <el-button
                type="primary"
                @click="search(-11)"
                v-if="navi.prev"
              >
                《《
              </el-button>
              <el-date-picker
                v-model="mth"
                type="month"
                placeholder="选择月"
                value-format="yyyy-MM"
                @change="search(1)"
              >
              </el-date-picker>
              <el-button
                type="primary"
 
                @click="search(11)"
                v-if="navi.next"
                >》》</el-button
              >
            </div>
          </el-col>
           <el-col v-if="ygShow" :span="6">
            <el-form-item label="钉钉报销id">
              <el-input v-model="searchParams.rmid"></el-input>
            </el-form-item>
          </el-col>
            <div class="search-btn" v-if="ygShow">
              <el-button type="success" icon="el-icon-search" @click="search"
                >搜索</el-button>
              <el-button @click="clearSearchVal">清空</el-button>
            </div>

        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <el-button
        type="success"
        size="mini"
        v-has-permission-code-and="'003500350015'"
        @click="toUpload"
        icon="el-icon-plus"
        >导入</el-button
      >
      <el-button
        type="danger"
        size="mini"
        v-has-permission-code-and="'003500350015'"
        icon="el-icon-delete"
        @click="batchRemove()"
        >删除</el-button
      >
          {{ msg }}
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData"
        stripe
        border
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
        ></el-table-column>
       <el-table-column
          prop="dpt"
          width="80"
          label="部门"
        ></el-table-column>

        <el-table-column
          prop="bxemp"
          width="80"
          label="报销人"
        ></el-table-column>
        <el-table-column
          prop="rmtm"
          width="110"
          label="报销时间"
        ></el-table-column>
        <el-table-column
          prop="name"
          width="220"
          label="报销名称"
        ></el-table-column>
        <el-table-column
          prop="cost"
          width="110"
          label="报销金额(元)"
        ></el-table-column>
        <el-table-column prop="cnt" width="85" label="子项数"></el-table-column>
        <el-table-column
          prop="paytm"
          width="110"
          label="发放时间"
        ></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column label="操作" fixed="right" width="110px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button type="primary" size="mini" @click="toDetail(scope.row)"
                >明细</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="page.size"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="上传月度报销数据"
      :visible.sync="dialogTableVisible"
      width="25%"
      :before-close="handleClose"
      :modal="false"
    >
      <br />
      <span>拖拽excel文件到此上传:</span>
      <excel-Upload
        drag
        v-model="excel"
        size="4096"
        model="fileSystem"
        uri="/statics/account"
        v-on:change="uploadSuccess"
      ></excel-Upload>
      <br /><br />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <show ref="show"></show>
  </div>
</template>
<script>
import show from "./show.vue";
import api from "@/api/cw/riems.js";
import excelUpload from "@/components/biz/fileUpload/excelUpload.vue";

export default {
  name: "riems",
  components: {
    show,
    excelUpload,
  },
  data() {
    return {
      searchParams: {},
      dialogTableVisible: false,
      excel: "",
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      page: new this.$constant.pageObj(),

      mth: "",
      navi: {},
      me: {},
      msg:"",
      sumPay:0,
      ygShow: false

    };
  },
  methods: {
    // 员工导航是否显示下一位
    isCanShEmpNxt() {
      if (this.emps) {
        return this.empidx < this.emps.length - 1;
      }
      return false;
    },
    //获取数据
    list() {
      this.listLoading = true;

      if (this.month && Date == typeof this.month) {
        this.searchParams.month = this.month.format("yyyy-MM");
      }

      let params = this.$utils.merger(this.searchParams, this.page);

      api.list(params, (response) => {
        this.listData = response.data.pages;
        this.navi = response.data.navi;
        this.mth = new Date(this.navi.crnt.replaceAll("-", "/") + "/01");

        this.listLoading = false;
      });
    },
    uploadSuccess(res) {
      if (res && res.length > 5) {
        let file = this.excel.substr(this.excel.lastIndexOf("/") + 1);

        api.toUpld(
          { fname: file },
          (resx) => {
            this.$alert(
              "上传(" +
                resx.data.cnt +
                ")条报销子项，合计金额(" +
                resx.data.sum +
                ")元成功。",
              {
                confirmButtonText: "确定",
              }
            );
          },
          (err) => {
            this.$alert("上传成功但解析数据失败", "请联系管理员。", {
              confirmButtonText: "确定",
            });
          }
        );
        this.dialogTableVisible = false;
      } else {
        this.$alert("上传失败", "请联系管理员。", {
          confirmButtonText: "确定",
        });
        this.dialogTableVisible = false;
      }
    },
    handleClose() {},
    //去添加
    toUpload() {
      //准备上传
      this.dialogTableVisible = true;
    },
    //去详情
    toDetail(row) {
      this.$refs.show.open(row, "【" + row.name + "】-报销明细", true);
    },

    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let parameter = {
        ids: this.selected,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          {
            ids: this.selected,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      let sumVal = 0;
      this.sumPay = 0;

      for (let item of val) {
        this.selected.push(item.id);
        sumVal += item.cost * 1;
        if(item.paytm){
            this.sumPay += item.cost * 1;
        }
      }

       if (this.selected.length > 0) {
        this.msg =
          "  已选择: " +
          this.selected.length +
          " 项,报销合计: " +
          sumVal.toFixed(2) +
          " 元,其中已发放:"+ this.sumPay+"元";
      } else {
        this.msg = "";
        this.sumPay = 0;
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },
    //搜索
    search(type) {
      if (type) {
        if (type == -11) {
          //上1月
          this.searchParams.mth = this.navi.prev;
        } else if (type == 11) {
          //下1月
          this.searchParams.mth = this.navi.next;
        } else if (type == 1) {
          // 时间选择器
          this.searchParams.mth = this.mth;
        }
      }
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
      this.mth = "";
      this.rmid = "";
      this.msg = "";
      this.sumPay = 0;
      this.list();
    },
  },
  mounted() {
    // 前端取回自己
    this.me = this.$caches.user.get();

    if (this.me.role == "ad" || this.me.role2 == "mgr") {
      this.ygShow = true;
    }
   
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
.operator {
  margin-top: 4px;
}
.errorClass {
  margin-top: 4px;
}
.box {
  display: flex;
}
.box2 {
  display: flex;
  margin: 0px 10px;
}
</style>

